require('waypoints/lib/noframework.waypoints');
require('waypoints/lib/shortcuts/inview');
export default class InviewManager {
  element: any;
  callback: any;
  inview: any;
  constructor(element, callback){
    let Waypoint   = window['Waypoint'];
    this.element   = element;
    this.callback = callback;
    // 時間差を作ってあげないとWaypointが間違ったポジションを認識することがある。
    let func = () => {
      this.inview = new Waypoint.Inview({
        element: this.element,
        entered: (direction) => {
          this.entered();
        }
      })
    }
    setTimeout(func, 333);
  }
  destroy(){
    this.inview.destroy();
  }
  entered(){
    this.destroy();
    this.callback();
  }
}
